var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center gap-[5px]"
  }, [_c('span', [_vm._v(_vm._s(_vm.masker.text))]), _c('Icon', {
    staticClass: "text-[20px]",
    attrs: {
      "type": _vm.masker.icon
    },
    on: {
      "click": _vm.changeEye
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };